<!--
  File name: Footer.vue
  Program Description:
    - A title component that displays an error message.
-->
<template>
  <div>
    <component
      :is="wrapper"
      v-bind="bind"
    >
      <slot />
    </component>
    <v-scroll-y-transition>
      <p
        v-show="showError"
        :style="{
          color: 'rgb(255, 82, 82)',
          fontWeight: '700',
          margin: 0
        }"
      >
        {{ errorMessage }}
      </p>
    </v-scroll-y-transition>
  </div>
</template>

<script>
export default {
  name: 'LabelError',
  props: {
    showError: {
      type: Boolean,
      default: true
    },
    errorMessage: {
      type: String,
      default: 'Field is required.'
    },
    bind: {
      type: Object,
      default: undefined
    },
    wrapper: {
      type: String,
      default: 'h2'
    }
  }
}
</script>
